module.exports = __webpack_public_path__ + "img/icon-sb-mattress-extra-firm-boutique-40.0e6862c.svg";